import { createSelector } from 'reselect';
import { MemberState } from './types';

const selectCache = (state: any) => state.memberCache;

export const selectIsSubmitting = createSelector(
  selectCache,
  (cache: any) => cache.submitting
);

export const selectIsFetchingOrgProfile = createSelector(
  selectCache,
  (cache: any) => cache.fetchingOrgProfile
);

export const selectErrorMessage = createSelector(
  selectCache,
  (cache: any) => cache.error
);

export const selectIsModalOpen = createSelector(
  selectCache,
  (cache: any) => cache.isModalOpen
);

export const selectIsNewRecordAdded = createSelector(
  selectCache,
  (cache: any) => cache.isNewRecordAdded
);

export const selectType = createSelector(
  selectCache,
  (cache: any) => cache.type
);

export const selectData = createSelector(
  selectCache,
  (cache: any) => cache.data
);

export const selectMemberUpdated = createSelector(
  selectCache,
  (cache: any) => cache.orgProfileUpdated
);

export const selectOrganisationProfile = createSelector(
  selectCache,
  (cache: any) => cache.orgProfile
);

export const selectOrganisationTenants = createSelector(
  selectCache,
  (cache: MemberState) => cache.orgTenants
);

export const selectGettingOrgTenants = createSelector(
  selectCache,
  (cache: MemberState) => cache.gettingOrgTenants
);
